
<template lang="pug">
v-container
    v-card(light, flat)
        v-row
            v-spacer
            v-col.text-center
                .text-h3 SCADAsure
            v-spacer
        v-row
            v-spacer
            v-col.flex-shrink-1.flex-grow-0
                v-img(src='icons8-hand-holding-shield-150.png', height='150', width='150')
            v-spacer

    v-row(v-if='massiveError')
        v-col.text-center
            v-card(light, flat)
                v-card-text
                    v-icon(color='red', size='64') running_with_errors
                    br
                    span.font-weight-bold A Critical Error has occurred.
                    br
                    span.font-weight-bold Please Try again later or contact Dorsett Controls Support.
                    br
                    span Error: "{{massiveError}}"
                    br
                    .text-h6.brand--text Support
                    span.font-weight-bold Email
                    br
                    a.brand--text(:href='`mailto:${support.email}`', target='_blank') {{ support.email }}
                    br
                    br
                    span.font-weight-bold Phone
                    br
                    a.brand--text(:href='`tel:${dorsett.number}`', target='_blank', rel='noopener noreferrer') {{ dorsett.number }}
    template(v-if='!hasPAMonitor')
        .d-flex
            v-spacer
            v-card(light, max-width='750', flat)
                .text-center
                    v-row
                        v-col
                            .productDescription
                                p.title {{productDescription}}
                    v-row
                        v-col
                            .productUseCase
                                p {{productUseCase}}
                    template(v-if='existingRequest && !hasPAMonitor')
                        v-row
                            v-col
                                p.font-weight-bold A request has been made to activate this feature on your server on {{existingRequestDate}}
                        v-row
                            v-col
                                p The following contact information was provided for the request:
                                ul.text-left
                                    li {{existingRequest.customersSubscriptionRequest.name}}
                                    li {{existingRequest.customersSubscriptionRequest.phoneNumber}}
                                    li {{existingRequest.customersSubscriptionRequest.email}}
                                p If the information is incorrect, please contact sales.
                    template(v-else)
                        template(v-if='priceFetchError')
                            span.warning--text There was an error fetching the product pricing.
                        template(v-else)
                            v-row
                                v-col
                                    .title Sign up now for only ${{price.price}}/month with a ${{price.setup_fee}} setup fee.
                        v-row
                            v-col
                                RequestForm(serviceName='SCADAsure', @done='getRequests')
            v-spacer
    template(v-else)
        v-row(v-if='monitorData && !misconfigured')
            v-spacer
            v-col(justify='left', cols='11')
                v-card(light, flat)
                    v-row
                        v-col(justify='left', cols='4' v-for="drive in masterDiskData.arrayOfDriveLetters", v-bind:key="drive.letter")
                            chartjsPieChart(
                                :name="drive.letter",
                                :seriesData="drive.formattedSeriesData"
                                :spaceRemaining="drive.freePercentage"
                            )
                    v-row
                        v-col(justify='left', cols='1')
                            v-icon.mr-1(size='128' v-if="internetAvailable && hasOnlineMonitor" color="green") check
                            v-icon.mr-1(size='128' v-if="!internetAvailable && hasOnlineMonitor" color="red") close
                            v-icon.mr-1(size='128' v-if="!hasOnlineMonitor" color="brand") build_circle
                        v-col(cols='4' align-self="center" class="text-h2")
                            span(v-if="hasOnlineMonitor") Internet Available
                            span(v-if="!hasOnlineMonitor") Internet Monitor Not Configured
                    v-row
                        v-col(justify='left', cols='1')
                            v-icon.mr-1(size='128' v-if="infoScanServices && hasInfoscanMonitor" color="green") check
                            v-icon.mr-1(size='128' v-if="!infoScanServices && hasInfoscanMonitor" color="red") close
                            v-icon.mr-1(size='128' v-if="!hasInfoscanMonitor" color="brand") build_circle
                        v-col(cols='4' align-self="center" class="text-h2")
                            span(v-if="hasInfoscanMonitor") Infoscan Services
                            span(v-if="!hasInfoscanMonitor") Infoscan Services Not Configured
        v-row(v-if= 'monitorData && misconfigured')
            v-col.text-center
                v-card(light, flat)
                    v-card-text
                        v-icon(color='red', size='64') running_with_errors
                        br
                        span.font-weight-bold Contact Dorsett Controls to finish setting up your SCADAsure
                        br
                        span(v-if="errorText") Error: "{{errorText}}"
                        span(v-if="!errorText") Error: "Response was empty, likely a mismatch between Timezone and CID"
                        br
                        .text-h6.brand--text Support
                        span.font-weight-bold Email
                        br
                        a.brand--text(:href='`mailto:${support.email}`', target='_blank') {{ support.email }}
                        br
                        br
                        span.font-weight-bold Phone
                        br
                        a.brand--text(:href='`tel:${dorsett.number}`', target='_blank') {{ dorsett.number }}
</template>

<script>
import { mapActions} from 'vuex';
import dashboard from '@/components/dashboard.vue';
import chartjsPieChart from '@/components/portal/paMonitor/chartjsPieChart';
import RequestForm from './RequestForm.vue';

const PRODUCT_DESCRIPTION = `
    SCADAsure is a proactive monitoring & notification capability designed to alert your team to disruptive
    events which could lead to an interruption in SCADA services. Specific use cases and product features are detailed below...
`;
const PRODUCT_USE_CASE = `
    Just because you're not receiving notifications or alarms on InfoScan doesn't mean the system is functioning normally.
    The apparent calmness may be the result of a digital service disruption suck as loss of server connection or lack of 
    hard drive space, and you may not realize this disruption exists before process failure occurs. SCADAsure is the security 
    blanket to protect against this threat - it surveys the health of your InfoScan environment continuously and alerts you
    to any issues.
`;

export default {
    name: 'PortalpaMonitor',
    extends: dashboard,
    components: {
        chartjsPieChart,
        RequestForm
    },
    data () {
        return {
            monitorData: "",
            misconfigured: false,
            errorText: "",
            massiveError: "",
            masterDiskData:{},
            hasPAMonitor: false,
            internetAvailable: false,
            hasOnlineMonitor: false,
            infoScanServices: false,
            hasInfoscanMonitor: false,
            dorsett: {
                name: 'Dorsett Controls',
                address: '486 N. Patterson Ave. Suite 301',
                city: 'Winston Salem',
                state: 'NC',
                zip: '27101-4264',
                number: '1-855-DT SCADA (387-2232)',
                email: 'info@dorsettcontrols.com',
                fax: '(336) 679-8811'
            },
            training: {
                email: 'training@dorsettcontrols.com'
            },
            support: {
                email: 'support@dorsettcontrols.com'
            },
            sales: {
                email: 'sales@dorsettcontrols.com'
            },
            productDescription: PRODUCT_DESCRIPTION,
            productUseCase: PRODUCT_USE_CASE,
            price: {
                price: 0,
                setup_fee: 0
            },
            priceFetchError: false,
            existingRequest: null,
            existingRequestDate: null,
        };
    },
    methods: {
        ...mapActions([
            "getPaMonitor"
        ]),

        async getData (){
            this.getRequests();
            this.$set(this, 'errorText', "");
            try {
                const data = await this.getPaMonitor();
                this.$set(this, 'hasPAMonitor', data?.hasPAMonitor);
                if(data?.error){
                    this.$set(this, 'errorText', data.error);
                    if(data?.hasPAMonitor){
                        this.$set(this, 'misconfigured', true);
                        //this customer IS set up in our DB but is borked.  Give them a useful error.
                        return data;
                    }
                    //This customer IS NOT set up and we should point them to sales
                    return "";
                }
                this.$set(this, 'misconfigured', false);
                this.getDiskSpaceMonitor(data?.monitors?.monitor);
                this.getOnlineStatus(data?.monitors?.monitor);
                this.$set(this, 'massiveError', "");
                this.$set(this, "monitorData", data);
                return data;


            } catch (error) {
                //We failed at the earliest and most basic level.
                //Show the user a generic catastrophic error
                this.$set(this, 'massiveError', error);
            }

        },
        /**
         *
         * @param {Array} apiMonitorInfo contains API response for GET_MONITOR_INFO from PA Monitor
         */
        getOnlineStatus (apiMonitorInfo){
            const monitorArray = apiMonitorInfo;
            let hasOnlineMonitor = false;
            let isOnline = false;
            let hasInfoscanMonitor = false;
            let isInfoscanRunning = false;
            monitorArray?.forEach((monitor) =>{
                if(monitor.title === "Inventory Collector"){
                    hasOnlineMonitor = true;
                    if(monitor.status === "OK"){
                        isOnline = true;
                    }
                }else if(monitor.title.includes("Service")){
                    hasInfoscanMonitor = true;
                    if(monitor.status === "OK"){
                        isInfoscanRunning = true;
                    }
                }
            });

            //UI logic: if they don't have a monitor Display Not Configured,  if they have a monitor but it is in error show X, If both green show green
            this.$set(this, "internetAvailable", isOnline);
            this.$set(this, "hasOnlineMonitor", hasOnlineMonitor);
            this.$set(this, "hasInfoscanMonitor", hasInfoscanMonitor);
            this.$set(this, "infoScanServices", isInfoscanRunning);
        },

        /**
         *
         * @param apiMonitorInfo contains API response for GET_MONITOR_INFO from PA Monitor
         */
        getDiskSpaceMonitor (apiMonitorInfo){
            const monitorArray = apiMonitorInfo;
            if(monitorArray){
                const masterDiskData = {};
                const diskMonitor = monitorArray.filter(m => m.title.includes("Disk Space"))?.[0];

                //More likely a misconfiguration error than simply this monitor missing, but it could be possible such a customer exists?
                if(!diskMonitor?.errText){
                    //this.$set(this, "misconfigured", true);
                    return;
                }
                const driveDataStrings = diskMonitor.errText.split("[").filter(d => d !== "");
                masterDiskData.driveDataStrings = driveDataStrings;

                let arrayOfDriveLetters = [];

                driveDataStrings.forEach((drive) =>{
                    const driveInstance = drive.split(" ").filter(d => d !== "");
                    const driveLetter= {letter :driveInstance[0]};
                    driveLetter.freeSpace = parseFloat(driveInstance[1]);
                    driveLetter.freeSpaceSizing = driveInstance[2];
                    driveLetter.usedSpace = parseFloat(driveInstance[5]);
                    driveLetter.usedSpaceSizing = driveInstance[6];
                    driveLetter.totalSpace = driveLetter.freeSpace + driveLetter.usedSpace;
                    //This gets a percentage but it could contain a massive number of decimal places
                    driveLetter.freePercentage = driveLetter.freeSpace / driveLetter.totalSpace * 100;
                    driveLetter.usedPercentage = driveLetter.usedSpace / driveLetter.totalSpace * 100;
                    //So we'll round to two places.
                    driveLetter.freePercentage = Math.round(driveLetter.freePercentage *100) / 100;
                    driveLetter.usedPercentage = Math.round(driveLetter.usedPercentage *100) / 100;

                    let formattedSeriesData = [];
                    formattedSeriesData.push({
                        name: "Used Space",
                        y: driveLetter.usedPercentage,
                        z: driveLetter.usedSpace,
                        g: driveLetter.usedSpaceSizing
                    });
                    formattedSeriesData.push({
                        name: "Free Space",
                        y: driveLetter.freePercentage,
                        z: driveLetter.freeSpace,
                        g: driveLetter.freeSpaceSizing
                    });

                    driveLetter.formattedSeriesData = formattedSeriesData;
                    arrayOfDriveLetters.push(driveLetter);
                });

                masterDiskData.arrayOfDriveLetters = [...arrayOfDriveLetters];

                this.$set(this, "masterDiskData", masterDiskData);

            } else {
                //Getting here means: (the customer has entries in our database) AND ((the API request gave us a response) AND (was empty)). [likely malformed or mis-setup in our DB]
                //Tell the UI to inform the customer to contact us to fix a misconfiguration
                this.$set(this, "misconfigured", true);
            }
        },
        async getRequests () {
            this.existingRequest = null;
            try {
                const results = await this.get('getRequestsForCustomer', {
                    customerId: this.customerId
                });
                console.log(results);
                if (results.length) {
                    const existingRequest = results.find(r => r.customersSubscriptionRequest?.type === 'SCADAsure');
                    if (existingRequest) {
                        this.existingRequest = existingRequest;
                        const dateRequested = new Date(existingRequest.createdAt);
                        this.existingRequestDate = `${dateRequested.toLocaleDateString()} at ${dateRequested.toLocaleTimeString()}`;
                    }
                }
            } catch (err) {
                this.message = 'Something went wrong. Please try again. If the problem persists, contact Dorsett Customer Support';
                console.error(err);
            }
        },
        async getProductPricing () {
            try {
                const results = await this.get('getProductPricing', {
                    product: 'SCADAsure'
                });
                this.price = results;
            } catch (err) {
                this.priceFetchError = true;
                console.error('error fetching pricing', err);
            }
        }
    },
    watch: {
        customerId:{
            handler (newVal) {
                if(newVal){
                    this.getData();
                }
            },
            immediate: true
        },
    },
    computed: {
        customerId (){
            return this.$store.state.customerId;
        }
    },
    mounted () {
        this.getProductPricing();
    }
};
</script>
